import type { Route as VisitRoute } from '@routes/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/index'
import { useLocation, useParams } from '@tanstack/react-router'
import { useLogPageView } from 'helpers/vendor'
import { useEventJson, useEventQueryV4 } from 'hooks/api/event'
import { ampli } from 'models/ampli'
import { useEffect } from 'react'

import { VisitDetails } from '../../components/VisitDetails/VisitDetails'

const visitRouteId =
  '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/' satisfies typeof VisitRoute.id

export function IdentificationVisitDetailsPage() {
  useLogPageView(() => ampli.identificationEventDetailsViewed())

  const { requestId, subscriptionId } = useParams({ from: visitRouteId })

  const { data: event, error } = useEventQueryV4({
    subscriptionId,
    requestId,
  })
  const { data: eventJson, error: eventJsonError } = useEventJson({
    subscriptionId,
    requestId,
  })

  const location = useLocation()
  useEffect(() => {
    if (location.hash === '' || location.hash === '#') {
      document.getElementById('root')?.scrollTo({ top: 0 })
    }
  }, [location.hash, requestId])

  return <VisitDetails requestId={requestId} event={event} eventJson={eventJson} error={error ?? eventJsonError} />
}
